//bao migrate skip
import "./filtering.css";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../services/bao-service";
let bindingName = "filtering";
let defaults: Bindings.filtering = {
    filter: ko.observable({}),
    key: ko.observable(""),
    submit: () => { }
};
export class FilteringBinding {
    constructor(element: HTMLElement, valueAccessor: () => Bindings.filtering, viewModel: any) {
        this.Element = element;
        this.ValueAccessor = valueAccessor;
        this._createControl();
        this._loadValue();
        this._setRemoveButtonVisibility();
        let cfg = this.Options();
        let filterObject = ko.unwrap(cfg.filter);
        if (filterObject != null && ko.isObservable(filterObject[ko.unwrap(cfg.key)])) {
            this._subs.push(ko.unwrap(cfg.filter)[ko.unwrap(cfg.key)].subscribe(() => {
                this._loadValue();
            }));
        }
        ;
        if (ko.isObservable(cfg.filter)) {
            this._subs.push(cfg.filter.subscribe(() => {
                this._loadValue();
            }));
        }
    }
    private _subs: KnockoutSubscription[] = [];
    $button: JQuery;
    $input: JQuery;
    $submitButton: JQuery;
    $removeButton: JQuery;
    $container: JQuery;
    Element: HTMLElement;
    ValueAccessor: () => Bindings.filtering;
    private _cleanControl() {
        this.$input.val("");
        this._saveValue();
    }
    Options(): Bindings.filtering {
        let options: Bindings.filtering = $.extend({}, defaults, this.ValueAccessor());
        return options;
    }
    private _createControl() {
        this.$button = $("<span class='fal fa-filter'></span>");
        this.$input = $("<input type='text' class='form-control' />");
        this.$container = $("<div class='filtering-container'></div>");
        this.$submitButton = $("<button class='btn btn-default filtering-ok'></button>");
        this.$removeButton = $("<button class='btn btn-default filtering-remove'></button>");
        $(this.Element).css("position", "relative");
        $(this.Element).addClass("filtering");
        this.$container.hide();
        this.$container.append("<div class='input-group'><div class='input-group-btn'></div></div>");
        $(".input-group", this.$container).prepend(this.$input);
        $(".input-group-btn", this.$container).append(this.$submitButton);
        $(".input-group-btn", this.$container).append(this.$removeButton);
        this.$submitButton.append("<span class='fal fa-check'></span>");
        this.$removeButton.append("<span class='fal fa-trash-alt'></span>");
        $(this.Element).append(this.$button);
        $(this.Element).append(this.$container);
        //events
        this.$button.on("click." + bindingName, (e: any) => {
            this.$container.toggle();
            this.$input.focus();
            Bao.Utils.stopPropagation(e);
        });
        this.$input.on("click." + bindingName, (e: any) => {
            Bao.Utils.stopPropagation(e);
        });
        this.$input.on("keypress." + bindingName, (e: any) => {
            if (e.which == 13) {
                this._saveValue();
                this.Options().submit();
            }
        });
        this.$input.on("input." + bindingName + " propertychange." + bindingName, (e) => {
            this._setRemoveButtonVisibility();
        });
        this.$submitButton.on("click." + bindingName, (e: any) => {
            Bao.Utils.stopPropagation(e);
            this._saveValue();
            this.Options().submit();
        });
        this.$removeButton.on("click." + bindingName, (e: any) => {
            Bao.Utils.stopPropagation(e);
            this._cleanControl();
            this.Options().submit();
        });
        $(this.Element).data(bindingName, this);
    }
    private _setRemoveButtonVisibility() {
        if (this.$input.val() == "") {
            this.$removeButton.hide();
        }
        else {
            this.$removeButton.show();
        }
    }
    private _loadValue() {
        let cfg = this.Options();
        let filterObj = ko.unwrap(cfg.filter);
        if (filterObj != null) {
            var filterValue = ko.unwrap(filterObj[ko.unwrap(cfg.key)]);
            this.$input.val(filterValue);
        }
        else if (ko.isObservable(cfg.filter)) {
            cfg.filter({});
        }
        this._checkColor();
    }
    private _saveValue() {
        let cfg = this.Options();
        let filterValue = this.$input.val();
        let filterObject = ko.unwrap(cfg.filter);
        if (filterObject == null && ko.isObservable(cfg.filter)) {
            let o = {};
            o[ko.unwrap(cfg.key)] = filterValue;
            cfg.filter(o);
        }
        else if (filterObject != null) {
            filterObject[ko.unwrap(cfg.key)] = filterValue;
        }
        if (ko.isObservable(cfg.filter)) {
            cfg.filter.valueHasMutated();
        }
        this._checkColor();
        this.$container.hide();
    }
    private _checkColor() {
        if (this.$input.val() != "") {
            $(this.Element).addClass("filtered");
            this.$button.addClass("fas");
            this.$button.removeClass("fal");
        }
        else {
            $(this.Element).removeClass("filtered");
            this.$button.removeClass("fas");
            this.$button.addClass("fal");
        }
    }
    dispose() {
        ko.utils.arrayForEach(this._subs, (s) => {
            s.dispose();
        });
        this.$button.off("click." + bindingName);
        this.$input.off("click." + bindingName);
        this.$input.off("keypress." + bindingName);
        this.$input.off("input." + bindingName + " propertychange." + bindingName);
        this.$submitButton.off("click." + bindingName);
        this.$removeButton.off("click." + bindingName);
        $(this.Element).removeData(bindingName);
    }
}
//Knockout register logic for binding and extender
let binding: KnockoutBindingHandler = {
    init: function (element: HTMLElement, valueAccessor, allBindingsAccessor, viewModel) {
        if (valueAccessor()) {
            var bindingInstance = new FilteringBinding(element, valueAccessor, viewModel);
            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                bindingInstance.dispose();
            });
        }
    },
    after: ["sorting"]
};
ko.bindingHandlers[bindingName] = binding;